/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_DescInputs */

const en_mk_sec_desc = /** @type {(inputs: Mk_Sec_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controls that competitors usually reserve for an Enterprise plan ship as standard in KerjaBareng from the Team tier onward.`)
};

const id_mk_sec_desc = /** @type {(inputs: Mk_Sec_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol yang biasanya baru ada di paket Enterprise kompetitor, di KerjaBareng jadi bawaan sejak tier Tim.`)
};

/**
* | output |
* | --- |
* | "Controls that competitors usually reserve for an Enterprise plan ship as standard in KerjaBareng from the Team tier onward." |
*
* @param {Mk_Sec_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_desc = /** @type {((inputs?: Mk_Sec_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_desc(inputs)
	return en_mk_sec_desc(inputs)
});